import React from 'react';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

//Cada skeleton separado por componente
function SkeletonHeader() {

    return (
        <div style={{ display: 'flex', flexDirection: 'row', width: '85%', justifyContent: 'space-between' }}>
            <div></div>
            <div>
                <Skeleton baseColor="#b02424" highlightColor="#d9534f" height={28} width={300} />
                <Skeleton baseColor="#b02424" highlightColor="#d9534f" height={25} width={500} />
                <Skeleton baseColor="#b02424" highlightColor="#d9534f" height={20} width={200} />
            </div>
            <div>
                <Skeleton baseColor="#b02424" highlightColor="#d9534f" height={35} width={150} />
                <Skeleton baseColor="#b02424" highlightColor="#d9534f" height={35} width={150} />
            </div>
        </div>
    );
}

function SkeletonFrase() {

    return (
        <div style={{ display: 'flex', width: '100%', flexDirection: 'column', alignItems: 'center', marginTop: '20px' }}>
            <Skeleton height={30} width={600} />
            <Skeleton style={{ marginTop: '10px' }} height={30} width={800} />
        </div>
    );
}
function SkeletonBody() {

    return (
        <div>
            <div style={{ display: 'flex' }}>
                <div style={{ display: 'flex', width: '100%', flexDirection: 'column' }}>
                    <Skeleton height={20} width={100} />
                    <Skeleton height={10} width={180} />
                </div>
                <div style={{ display: 'flex', width: '100%', flexDirection: 'column' }}>
                    <Skeleton height={20} width={100} />
                    <Skeleton height={10} width={180} />
                </div>
                <div style={{ display: 'flex', width: '100%', flexDirection: 'column' }}>
                    <Skeleton height={20} width={100} />
                    <Skeleton height={10} width={180} />
                </div>
                <div style={{ display: 'flex', width: '100%', flexDirection: 'column' }}>
                    <Skeleton height={20} width={100} />
                    <Skeleton height={10} width={180} />
                </div>
                <div style={{ display: 'flex', width: '100%', flexDirection: 'column' }}>
                    <Skeleton height={20} width={100} />
                    <Skeleton height={10} width={180} />
                </div>
            </div>
            <Skeleton style={{ marginTop: '50px' }} height={35} width={200} />
            <Skeleton style={{ marginTop: '20px' }} height={300} width='100%' />
        </div>
    );
}

function SkeletonStepper() {

    return (
        <div className="skeleton-container">
            <div className="skeleton-title">
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>
                    <Skeleton height={50} width={50} circle={true} />
                    <Skeleton height={5} width={100} style={{ marginLeft: '20px' }} />
                    <Skeleton height={50} width={50} circle={true} style={{ marginLeft: '20px' }} />
                    <Skeleton height={5} width={100} style={{ marginLeft: '20px' }} />
                    <Skeleton height={50} width={50} circle={true} style={{ marginLeft: '20px' }} />
                    <Skeleton height={5} width={100} style={{ marginLeft: '20px' }} />
                    <Skeleton height={50} width={50} circle={true} style={{ marginLeft: '20px' }} />
                    <Skeleton height={5} width={100} style={{ marginLeft: '20px' }} />
                    <Skeleton height={50} width={50} circle={true} style={{ marginLeft: '20px' }} />
                    <Skeleton height={5} width={100} style={{ marginLeft: '20px' }} />
                    <Skeleton height={50} width={50} circle={true} style={{ marginLeft: '20px' }} />
                </div>
            </div>
        </div>
    );
}

function SkeletonStatus() {

    return (
        <div className="skeleton-container">
            <div className="skeleton-title">
                <div style={{ marginTop: '150px', display: 'flex', justifyContent: 'center' }}>
                    <div style={{ marginRight: '100px' }}>
                        <Skeleton height={20} width={200} />
                        <Skeleton height={20} width={200} style={{ marginTop: '20px' }} />
                        <Skeleton height={20} width={150} />
                        <Skeleton height={20} width={100} />
                    </div>
                    <div style={{ marginLeft: '100px' }}>
                        <Skeleton height={20} width={200} />
                        <Skeleton height={20} width={200} style={{ marginTop: '20px' }} />
                        <Skeleton height={20} width={150} />
                        <Skeleton height={20} width={100} />
                    </div>
                </div>
            </div>
        </div>
    );
}
function SkeletonStepperMobile() {

    return (
        <div className="skeleton-container">
            <div className="skeleton-title">
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px', flexDirection: 'column', marginLeft: '30px' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }} >
                        <Skeleton height={50} width={50} circle={true} />
                        <Skeleton height={15} width={100} style={{ marginLeft: '20px' }} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Skeleton height={100} width={5} style={{ marginTop: '20px', marginLeft: '20px' }} />
                        <Skeleton height={15} width={100} style={{ marginLeft: '20px' }} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }} >
                        <Skeleton height={50} width={50} circle={true} />
                        <Skeleton height={15} width={100} style={{ marginLeft: '20px' }} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Skeleton height={100} width={5} style={{ marginTop: '20px', marginLeft: '20px' }} />
                        <Skeleton height={15} width={100} style={{ marginLeft: '20px' }} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }} >
                        <Skeleton height={50} width={50} circle={true} />
                        <Skeleton height={15} width={100} style={{ marginLeft: '20px' }} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Skeleton height={100} width={5} style={{ marginTop: '20px', marginLeft: '20px' }} />
                        <Skeleton height={15} width={100} style={{ marginLeft: '20px' }} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }} >
                        <Skeleton height={50} width={50} circle={true} />
                        <Skeleton height={15} width={100} style={{ marginLeft: '20px' }} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Skeleton height={100} width={5} style={{ marginTop: '20px', marginLeft: '20px' }} />
                        <Skeleton height={15} width={100} style={{ marginLeft: '20px' }} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }} >
                        <Skeleton height={50} width={50} circle={true} />
                        <Skeleton height={15} width={100} style={{ marginLeft: '20px' }} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Skeleton height={100} width={5} style={{ marginTop: '20px', marginLeft: '20px' }} />
                        <Skeleton height={15} width={100} style={{ marginLeft: '20px' }} />
                    </div>
                    <Skeleton height={50} width={50} circle={true} style={{ marginTop: '20px' }} />
                </div>
            </div>
        </div>
    );
}

export { SkeletonHeader, SkeletonFrase, SkeletonStepper, SkeletonStatus, SkeletonStepperMobile, SkeletonBody };